import React from 'react';
import { motion } from 'framer-motion';
import { HeaderBox } from './style';
import { logoVariant } from "../../pages/Homepage/animations"

export const Header = ({setNavigation, showIcon, isNavigationOpen, type}) => {
  return (
  <HeaderBox className="header" showNavigation={setNavigation} isNavigationOpen={isNavigationOpen}>
    <motion.div variants={logoVariant} animate='visible' initial="hidden" className="logoContainer">
      <img src={isNavigationOpen ? "/images/my logo.png" : "/images/my logo2.png"} style={{display: type==="contact" ? "none" : "block" || (type==="about" && "block" )}} alt='logo' />
      <div className="logoText" style={{display: type==="contact"}}>
        <motion.span className='name' initial={{opacity: 0, y: 10}} animate={{opacity: 1, y: 0}} transition={{delay: 1.8}} style={{color: isNavigationOpen ? "black" : "white"}}>Moses Chukwunekwu</motion.span>
        <motion.p className='role' initial={{opacity: 0, y: -10}} animate={{opacity: 1, y: 0}} transition={{delay: 2.2}}>Software Developer</motion.p>
      </div>
    </motion.div>
</HeaderBox>
)
}